import { makeAutoObservable, runInAction } from 'mobx';
import agent from 'src/api/agent';
import { notification, notificationparams } from 'src/@types/notification';
import { getIDforHiglightTableRecord, removeIDforHiglightTableRecord } from 'src/utils/general';

export default class notificationStore {
  NotificationRegistry = new Map<number, notification>();

  editMode = false; //When click on edit button

  totalRecord: number | undefined;

  highlightID: number | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get notificationList() {
    return Array.from(this.NotificationRegistry.values());
  }

  setNotificationList = (Info: notification) => {
    this.NotificationRegistry.set(Info.id!, Info);
  };

  // Load Archive List
  loadNotification = async (param: notificationparams) => {
    try {
      this.totalRecord = undefined;
      const result = await agent.Notification.getNotificationList(param);
      const notificationUreadList = await agent.Notification.getNotificationUnreadList();
      this.NotificationRegistry.clear();
      runInAction(() => {
        if (result) {
          this.totalRecord = notificationUreadList.data;
          result.data.data.forEach((lst: any) => {
            this.setNotificationList(lst);
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  setHighLightID = (type?: any) => {
    if (type === 0) {
      removeIDforHiglightTableRecord();
      this.highlightID = 0;
    } else {
      this.highlightID = getIDforHiglightTableRecord();
    }
  };

  readNotification = async (id: number) => {
    try {
      await agent.Notification.readNotification(id);
      runInAction(() => {
        this.setHighLightID();
        this.loadNotification({ pageIndex: 0, pageSize: 5 });
      });
    } catch (error) {}
  };
}
